export default {
  login: {
    "Welcome_to_TC_system": "Welcome to TC system",
    "Login_account": "Login account",
    "Please_enter_your_login_account": "Please enter your login account",
    "Login_password": "Login password",
    "Please_enter_your_login_password": "Please enter your login password",
    "Remember_the_account_password": "Remember the account password",
    "Enterprise_wechat_login": "Enterprise wechat login",
    "Log_in": "Log in",
    "logining": "logining",
    "Login_success": "Login success",
    "Login_failure": "Login failure",
    "exit": "exit",
    "exiting": "exiting",
    "Exit_successfully": "Exit successfully",
    "Exit_failure": "Exit failure",
    "Welcome_to_login_TC_system": "Welcome to login TC system",
    "account": "account",
    "Password": "Password",
    "Please_enter_login_account": "Please enter login account",
    "Please_enter_login_password": "Please enter login password",
    "Log_in_Wecom": "Log in Wecom",
    "It_is_on_the_access_road": "It is on the access road",
    "Access_error": "Access error",
  },
  menu: {
    "WarehouseData": "warehouse data",
    "operate_time": "operate time",
    "View_details": "View details",
    "Warehousing_management": "Warehousing",
    "Out_warehouse_management": "Out warehouse",
    "Order_management": "Order management",
    "Pallet_management": "Pallet management",
    "Abnormal_data": "Abnormal data",
    "Warehousing_anomaly": "Warehousing anomaly",
    "Outgoing_exception": "Outgoing exception",
    "Operation_exception": "Operation exception",
    "Basic_setup": "Basic setup",
    "Vehicle_management": "Vehicle management",
    "Order_list": "Order list",
    "warehouse_data": "warehouse data",
    "goods_age_statistics": "goods age statistics",
    "data_statistics": "data statistics",
    "classification_data": "classification data",
    "classification_details": "classification details",
    "pela_details": "pela details",
    "cargo_entry_management": "cargo entry management",
    "cargo_entry_details": "cargo entry details",
    "Shipment_details": "Shipment details",
    "load_output_administration": "load output administration",
    "load_output_details": "load output details",
    "order_administration": "order administration",
    "order_details": "order details",
    "abnormal_load_input_situation": "abnormal load input situation",
    "abnormal_situation_details": "abnormal situation details",
    "load_output_abnormal_situation": "load output abnormal situation",
    "abnormal_driving_situation": "abnormal driving situation",
    "container_administration": "container administration",
    "container_details": "container details",
    "location_management": "location management",
    "classification_management": "classification management",
    "platform_management": "platform management",
    "car_management": "car management",
    "Mercado_Libre_Reservation": "Mercado Libre Reservation",
    "Reservation_status": "Reservation status",
    "Check_the_shipment_number": "Check the shipment number",
    "Warehouse_details": "Warehouse details",
    "Enterprise_architecture_management": "Enterprise architecture management",
    "System_setting": "System setting",
    "Department_setting": "Department setting",
    "Employee_account_management": "Employee account management",
    "Role_rights_management": "Role rights management",
    "Role_setting": "Role setting",
    "Authority_management": "Authority management",
    "Work_order_management": "Work order management",
    "Add_new_work_order": "Add new work order",
    "Work_order_details": "Work order details",
    "Customer_service_Settings": "Customer service Settings",
    "Work_order_type": "Work order type",
    "Problem_type": "Problem type",
    "Drafts": "Drafts",
    "check": "check",
    "add": "add",
    "intercept": "intercept",
    "updateFiles": "updateFiles",
    "delete": "delete",
    "cancel": "cancel",
    "edit": "edit",
    "download": "download",
    "storage_management": "storage management",
    "No_owner_claimed_the_goods": "No owner claimed the goods",
    "return_claim": "return claim",
    "loadingLot": "loading lot",
    "lotDetail": "lot detail",
    "return_goods": "Returns/USA_Mexico",
    "returnGoods": "Returns/USA_Mexico",
    "warehouse": "Warehousing",
    "outwarehouse": "Out warehouse",
    "refuseOutwarehouse": "Refuse to return to warehouse",
    "transfer": "Transfer",
    "inventory": "Inventory",
    "pickGoods": "Pick goods",
    "listGoods": 'Cargo handling',
    "outerSheet": "Carton label",
    "productSheet": "Product label",
    "findGoods": "Check the goods",
    "claimGoods": "Cargo claim",
    "truckLoading": "entrucking",
    "picsUpload": "Picture upload",
    "changeLabel": "change label",
    "checkZone": "Check the location",
    "Update": "Update",
    "pda": "pda",
    "areaScan": "area scan",
    "goods_ageing": "goods ageing",
    "zoneInventory": "zone inventory",
    "workSheet": "Work order processing",
    "storage_list": "storage list",
    "storage_of_goods": "Goods Storage",
    "cargo_storage_details": "cargo storage details",
    "cargo_delivery_information": "Information on Cargo Delivery to Warehouse",
    "abnormal_shipments": "Inventory Abnormal Shipments",
    "first_route_order": "first route order",
    "transfer_warehouse_order": "transfer warehouse order",
    "order_detail": "order detail",
    "transferWarehouseProcess": "transfer warehouse process",
    "transferToWarehouse": "transfer to warehouse",
    "warehouseOrder": "warehouse Order",
    "drop_shipping_outwarehouse": "drop shipping outwarehouse",
    "drop_shipping_outwarehouse_detail": "drop shipping outwarehouse detail",
    "picking_task": "picking task",
    "picking_order": "picking order",
    "picking_outwarehouse": "picking outwarehouse",
    "task_detail": "task detail",
    "warehousing_manage": "warehousing manage",
    "container_manage": "Dropshipping Container Management",
    "location_manage": "Dropshipping Storage Location Management",
    "distribution_manage": "distribution manage",
    "shelves_manage": "shelves manage",
    "pull_on_shelves_list": "pull on shelves list",
    "pull_off_shelves_list": "pull off shelves list",
    "warehouse_manage": "warehouse manage",
    "goods_stock": "goods stock",
    "sku_stock": "Total SKU inventory",
    "sku_batch_stock": "SKU Batch Inventory",
    "sku_shelf_stock": "SKU shelf stock",
    "inventory_adjustment": "inventory adjustment",
    "container_detail": "container detail",
    "product_information": "product information",
    "order_manage": "order manage",
    "all_order": "all order",
    "shein_order": "SHEIN order",
    "warehouse_detail": "warehouse detail",
    "subarea_detail": "subarea detail",
    "location_detail": "location detail",
    "goods_stock_detail": "goods detail",
    "general_situation": "general situation",
    "batchOutWarehouse": "batch out warehouse",
    "UpdateTheOutboundTime": "Update the outbound time",
    "DestroyGoods": "Destroy goods",
    "system_setting": "System Settings",
    "courier_freight_manage": "Courier Freight Management",
    "setupOutaccount": "Set up outgoing account",
    "shipment": "Shipment number information",
    "changeShipment": "Change the shipment number for re-labeling",
    "batchDistributionWorkSheet": "Batch distribution worksheet",
    "warehouse_order": "Warehouse Order",
    "new_order": "New Order",
    "good_change_label": "Change Cargo Label",
    "good_change_label_detail": "Details of Cargo Label Change",
    "account_information": "Account Information",
    "login": "Login",
    "logout": "Logout",
    "userinfo": "User Information",
    "operating_function": "Operating Function",
    "Home_Page_Functions": "Home Page Functions",
    "goods_sku_stock": "Inventory of goods SKU",
    "goods_in_warehouse": "goods warehousing",
    "out_of_stock_order_change_label": "Change Label for Stock-Out Order",
    "out_of_stock_order_change_label_details": "Details of Label Change for Stock-Out Order",
    "rfid": "RFID",
    "search_goods_task": "Goods Search Task",
    "search_goods_task_details": "Goods Search Task Details",
    "related_sub_order": "Related Sub-order",
    "inbound_inspection_task": "Inbound Inspection Task",
    "inbound_inspection_task_details": "Inbound Inspection Task Details",
    "findGoodsOutwarehouse": "Inspect goods upon warehouse exit",
    "overseas_qr_code_statistics": "Overseas QR Code Statistics",
    "employee_name": "Employee Name",
    "Time_selection": "Time Selection",
    "Scan_code_statistics": "Scan Code Statistics",
    "Statistics_of_scanning_and_entering_warehouse": "Statistics of scanning and entering warehouse",
    "Scan-to-issue_statistics": "Scan-to-issue statistics",
    "Statistics_of_scanning_and_listing": "Statistics of scanning and listing",
    "Statistics_of_products_removed_from_shelves_after_scanning": "Statistics of products removed from shelves after scanning",
    "Scan_and_count_statistics": "Scan and count statistics",
    "Scan_outer_box_label_statistics": "Scan outer box label statistics",
    "Scan_product_labels_for_statistics": "Scan product labels for statistics",
    "warehouse_loading": "Warehouse loading",
    "Details_of_warehouse_delivery": "Details of warehouse delivery",
    "Warehouse_delivery": "Warehouse delivery",
    "Number_of_items_scanned_and_released_from_storage": "Number of items scanned and released from storage",
    "Number_of_items_to_be_issued_from_storage": "Number of items to be issued from storage",
    "Number_of_vehicles_that_should_be_loaded": "Number of vehicles that should be loaded",
    "Number_of_vehicles_loaded": "Number of vehicles loaded",
    "Number_of_units_not_loaded": "Number of units not loaded",
    "Please_select_the_delivery_date_first": "Please select the delivery date first",
    "Scanned_and_loaded": "Scanned and loaded",
    "Scanned_and_loaded_onto_the_vehicle": "Scanned and loaded onto the vehicle",
    "Loading_without_scanning_the_code": "Loading without scanning the code",
    "truckCarScan": "Loading Scan",
    "outbound_order_extraction_label": "Outbound order extraction label",
    "Tag_separation": "Tag separation",
    "abnormal_update_prompt": "Abnormal Update Prompt",
    "Are_you_sure_you_want_to_split_the_labels": "Are you sure you want to split the labels",
    "Are_you_sure_you_want_to_clear_all_uploaded_files": "Are you sure you want to clear all the uploaded files",
    "Please_enter_the_file_name": "Please enter the file name",
    "Please_upload_and_complete_the_segmentation_first": "Please upload and complete the segmentation first",
    "Please_select_the_warehouse_delivery_date": "Please select the warehouse delivery date",
    "Cleared": "Cleared",
    "No_files_available_for_upload": "No files available for upload",
    "In_the_process_of_packaging_and_uploading": "In the process of packaging and uploading",
    "Split_successfully": "Split successfully",
    "ocr_extract_excel": "OCR extract excel",
    "truck_loading_bonded_warehouse": "Truck loading bonded warehouse",
    "truck_loading_bonded_warehouse_details": "Truck loading bonded warehouse details",
    "warehousing_summary": "Warehousing summary",
    "warehousing_summary_details": "Warehousing summary details",
    "Amazon_appointment_delivery_registration": "Amazon Appointment Delivery Registration",
    "Amazon_delivery_shipping_information": "Amazon delivery shipping information",
    "Top_function": "Top function",
    "Large_screen_data_dashboard": "Large screen data dashboard",
    "show_board": "Show board function",
    "setUnknown": "Change the inventory to unknown",
  },
  selectPart: {
    "Operation_center": "Operation",
    "order_center": "Order",
    "Enterprise_center": "Enterprise center",
    "Service_center": 'Service center',
    "pda": "pda",
    "PDA_dropShipping": "PDA Dropshipping",
    "Inventory_center": "Inventory center",
    "distribution_center": "distribution center",
    "other_mode": "other modules",
  },
  warehouseData: {
    "Goods_to_be_listed": "Goods to be listed",
    "Container_code_to_be_listed": "Container code to be listed",
    "Current_pieces": "Current pieces",
    "Current_pieces_of_order/ticket": "Current pieces of order/ticket",
    "Total_weight": "Total weight",
    "Total_weight/volume": "Total weight/volume",
    "Pending_arrival_orders_at_the_warehouse": "Pending arrival orders at the warehouse",
    "Orders_pending_handling": "Orders pending handling",
    "abnormal_orders": "abnormal orders",
    "orders_that_have_been_held_for_a_long_time": "orders that have been held for a long time",
    "Total_pieces": "Total pieces",
    "Total_volume": "Total volume",
    "Total_order/ticket": "Total order/ticket",
    "Day": "Day",
    "Month": "Month",
    "Year": "Year",
    "cargo_intake_today/piece": "cargo intake today/piece",
    "Morning": "Morning",
    "Afternoon": "Afternoon",
    "cargo_departure_today/piece": "cargo departure today/piece",
    "Handling_today/piece": "Handling today/piece",
    "Classification_of_warehouse_area": "Classification of warehouse area",
    "Import_data": "Import data",
    "reservation_space_is_less_than": "reservation space is less than",
    "cargo_entry_worker": "cargo entry worker",
    "Time_of_warehousing": "Time of warehousing",
    "Warehouse": "Warehouse",
    "classification_area": "classification area",
    "pallet_number": "pallet number",
    "deposit_time": "deposit time",
    "secondary_shipment_number": "secondary shipment number",
    "secondary_shipping/secondary_outer_carton_label": "secondary shipping/secondary outer carton label",
    "Pieces": "Pieces",
    "Weight": "Weight",
    "Number_of_shipment": "Number of shipment",
    "Number_of_entering_warehouse": "Number of entering warehouse",
    "Number_of_products/tag": "Number of products/tag",
    "choose_classification_area": "choose classification area",
    "filter": "filter",
    "Reset": "Reset",
    "Client_name": "Client name",
    "Salesman": "Salesman",
    "deposit_time/day": "deposit time/day",
    "handling": "handling",
    "Check": "Check",
    "Please_enter_content": "Please enter content",
    "No_region_storage_information_was_entered": "No region storage information was entered",
    "Storage_space_less_than": "Storage space less than",
    "Search_results": "Search results",
    "Total": "Total",
    "Old_shipment_number": "Old shipment number",
    "Old_sub-shipment_number/shipping_mark": "Old sub-shipment number/shipping mark",
    "change_order_number": "change order number",
    "region_name": "region name",
    "status": "status",
    "Update_time": "Update time",
    "volume": "volume",
    "Data_export": "Data export",
    "Already_listed": "Already listed",
    "Taken_down": "Taken down",
    "De_listing": "De listing",
    "Total_number_of_locations": "Total number of storage locations",
    "The_number_of_used_storage_locations": "Number of used storage locations",
    "Number_of_empty_storage_locations": "Number of empty storage locations",
  },
  warehousing: {
    "delivery_number": "delivery number",
    "cargo_entry_number": "cargo entry number",
    "shipping/outer_box_label": "shipping/outer box label",
    "state": "state",
    "Container_pick_up_date": "Container pick up date",
    "cargo_entry_time": "cargo entry time",
    "import_data": "import data",
    "export_data": "export data",
    "Container_number": "Container number",
    "SO_number": "SO number",
    "filter": "filter",
    "reboot": "reboot",
    "pick_up_order_number/container_number": "pick up order number/container number",
    "type_of_transport": "type of transport",
    "related_shipping_quantity/pcs": "related shipping quantity/pcs",
    "total_pieces/piece": "total pieces/piece",
    "total_volume/cubic_meters": "total volume/cubic meters",
    "total_weight/kg": "total weight/kg",
    "warehouse_receipt_amount/piece": "warehouse receipt amount/piece",
    "review": "review",
    "secondary_shipment_number": "secondary shipment number",
    "secondary_shipping/secondary_outer_carton_label": "secondary shipping/secondary outer carton label",
    "product_parts/parts": "product parts/parts",
    "volume/cubic_meters": "volume/cubic meters",
    "weight/kg": "weight/kg",
    "have_been_entered": "have been entered",
    "total_pieces": "total pieces",
    "total_weight": "total weight",
    "total_volume": "total volume",
    "cargo_entry_parts": "cargo entry parts",
    "pieces_without_charge_entry": "pieces without charge entry",
    "driving": "driving",
    "print_income_sheet": "print income sheet",
    "export_income_sheet": "export income sheet",
    "warehousing": "warehousing",
    "Failed_to_get_warehousing_list": "Failed to get warehousing list",
    "Transport_type": "Transport type",
    "Failed_to_get_warehousing_details": "Failed to get warehousing details",
    "Failed_to_get_waybill_details": "Failed to get waybill details",
    "shipping": "shipping",
    "secondary_shipping": "secondary shipping",
    "location_code/container_code": "location code/container code",
    "all": "all",
    "warehoused": "warehoused",
    "exporting": "exporting",
    "Export_successfully": "Export successfully",
    "printing": "printing",
    "Print_successfully": "Print successfully",
    "Print_unsuccessfully": "Print unsuccessfully",
    "Company_logo": "Company logo",
    "Export_unsuccessfully": "Export unsuccessfully",
    "RFID_quantity": "Number of RFID items",
    "New_RFID_inbound_inspection_has_been_added": "New RFID inbound inspection has been added",
    "The_new_RFID_inbound_detection_has_been_successfully_added": "The new RFID inbound inspection has been successfully added",
    "The_new_RFID_inbound_inspection_failed": "The new RFID inbound inspection failed",
    "The_number_of_items_on_the_inventory_sheet_does_not_match_the_number_of_RFID_tags_Are_you_sure_you_want_to_proceed_with_creation": "The number of items on the inventory sheet does not match the number of RFID tags. Are you sure you want to proceed with creation?",
    "The_number_of_leading_stars_is_odd": "The number of leading stars is odd",
    "The_number_of_stars_received": "Number of stars received",
  },
  outwarehouse: {
    "delivery_number": "delivery number",
    "load_output_number": "load output number",
    "shipping/outer_box_label": "shipping/outer box label",
    "state": "state",
    "creation_date": "creation date",
    "cargo_departure_time": "cargo departure time",
    "related_shipping_quantity/pcs": "related shipping quantity/pcs",
    "scan_quantity/pieces": "scan quantity/pieces",
    "person_responsible_for_shipping": "person responsible for shipping",
    "shipping_car_number": "shipping car number",
    "secondary_shipment_number": "secondary shipment number",
    "secondary_shipping/secondary_outer_carton_label": "secondary shipping/secondary outer carton label",
    "successful_scan_parts": "successful scan parts",
    "parts_without_scanning": "parts without scanning",
    "download_authorization": "download authorization",
    "print_output_sheet": "print output sheet",
    "overload_attachment_information": "overload attachment information",
    "export_output_sheet": "export output sheet",
    "Create_delivery_list": "Create delivery list",
    "title": "title",
    "Total": "Total",
    "related_shipping_quantity": "related shipping quantity",
    "successful_number": "successful number",
    "reject_number": "reject number",
    "intercept_number": "intercept number",
    "creator": "creator",
    "address": "address",
    "Create_time": "Create time",
    "Delivery_time": "Delivery time",
    "remark": "remark",
    "driving": "driving",
    "view": "view",
    "delete": "delete",
    "Are_you_sure_to_delete": "Are you sure to delete",
    "confirm": "confirm",
    "cancel": "cancel",
    "waiting_for_out_warehouse": "waiting for out warehouse",
    "warehousing": "warehousing",
    "warehoused": "warehoused",
    "out_warehouse_abnormally": "out warehouse abnormally",
    "deleting": "deleting",
    "Successfully_delete": "Successfully delete",
    "Delete_unsuccessfully": "Delete unsuccessfully",
    "Failed_to_get_out_warehouse_list": "Failed to get out warehouse list",
    "Attached_file": "Attached file",
    "Only_support": "Only support",
    "format": "format",
    "upload": "upload",
    "save": "save",
    "saving": "saving",
    "Save_successfully": "Save successfully",
    "Save_unsuccessfully": "Save unsuccessfully",
    "Intercepted_number_of_out_warehouse": "Intercepted number of out warehouse",
    "Scan_list": "Scan list",
    "batch_out_warehouse": "batch out warehouse",
    "destroy_goods": "destroy goods",
    "out_warehouse_intercept": "out warehouse intercept",
    "Are_you_sure_to_out_warehouse?": "Are you sure to out warehouse?",
    "File_list": "File list",
    "batch_download": "batch download",
    "take_a_photo_and_send_back": "take a photo and send back",
    "Download": "Download",
    "close": "close",
    "Reject_list": "Reject list",
    "reject_reason": "reject reason",
    "filter": "filter",
    "reset": "reset",
    "edit": "edit",
    "Download_attachment": "Download attachment",
    "Update_attachment": "Update attachment",
    "Export_the_reject_list": "Export the reject list",
    "All": "All",
    "Scanned": "Scanned",
    "To_be_scanned": "To be scanned",
    "rejection": "rejection",
    "Failed_to_get_out_warehouse_details": "Failed to get out warehouse details",
    "Please_check_first": "Please check first",
    "Batch_delivery_successfully": "Batch delivery successfully",
    "Batch_out_warehouse_unsuccessfully": "Batch out warehouse unsuccessfully",
    "Failed_to_get_fileList": "Failed to get fileList",
    "File_is_empty": "File is empty",
    "Download_successfully": "Download successfully",
    "Download_unsuccessfully": "Download unsuccessfully",
    "Failed_to_get_scan_list": "Failed to get scan list",
    "The_attached_file_is_empty": "The attached file is empty",
    "exporting": "exporting",
    "Export_successfully": "Export successfully",
    "Export_unsuccessfully": "Export unsuccessfully",
    "Print_unsuccessfully": "Print unsuccessfully",
    "printing": "printing",
    "Print_successfully": "Print successfully",
    "intercept_reason": "intercept reason",
    "intercepting": "intercepting",
    "Intercept_successfully": "Intercept successfully",
    "Intercept_unsuccessfully": "Intercept unsuccessfully",
    "Edit_reject_reason": "Edit reject reason",
    "editing": "editing",
    "Edit_successfully": "Edit successfully",
    "Edit_failure": "Edit failure",
    "Please_upload_the_attached_file": "Please upload the attached file",
    "updating": "updating",
    "Update_successfully": "Update successfully",
    "Export_warehouse_orders_in_batches": "Export warehouse orders in batches",
    "Number_of_pieces_to_be_issued": "Number of pieces to be issued",
    "Platform": "Platform",
    "Export_excel_data_in_batches": "Export excel data in batches",
    "Export_the_pdf_of_the_swap": "Export the pdf of the swap",
    "Change_label_list": "Change label list",
    "Change_label_information_table": "Change label information table",
    "Error_table_of_label_change_information": "Error table of label change information",
    "List_of_unchanged_labels": "List of unchanged labels",
    "Storage_location_area": "Storage location area",
    "change_label_status": "change label status",
    "operator": "operator",
    "Error_cause": "Error cause",
    "Estimated_weight": "Estimated weight",
    "Estimated_volume": "Estimated volume",
    "abnormal_remark": "abnormal remark",
    "Number_of_items_that_should_be_shipped_out": "Number of items that should be shipped out",
    "Number_of_items_that_have_been_shipped_out": "Number of items that have been shipped out",
    "Number_of_items_that_have_not_been_shipped_out": "Number of items that have not been shipped out",
    "Number_of_intercepted_items": "Number of intercepted items",
    "Number_of_rejected_items": "Number of rejected items",
    "Number_of_items_that_should_have_outer_box_labels_changed": "Number of items that should have outer box labels changed",
    "Number_of_items_that_have_not_had_outer_box_labels_changed": "Number of items that have not had outer box labels changed",
    "Batch_processing_abnormal_child_orders": "Batch Processing of Abnormal Child Orders",
    "Appendix_to_authorization": "Appendix to Authorization",
    "Changing_attachment": "Attachment for Label Change",
    "Edit_Excel_Content": "Edit Excel Content",
    "Multiple_separated_by_Chinese_commas,_for_example:": "Multiple separated by Chinese commas, for example:",
    "Old_shipment_number_information": "Old Shipment Number Information",
    "Please_enter_remarks": "Please enter remarks",
    "Update_failure": "Update Failure",
    "Please_wait_until_the_file_is_uploaded": "Please wait until the file is uploaded",
    "Edit_SKU": "Edit SKU",
    "replace_SKU_or_not": "Replace SKU or not",
    "Change_total_quantity": "Change total quantity",
    "Old_SKU": "Old SKU",
    "New_SKU": "New SKU",
    "Update_total_quantity": "Update total quantity",
    "Add": "Add",
    "Confirm": "Confirm",
    "change": "Replace",
    "Do_not_replace": "Do not replace",
    "Please_Enter_Old_SKU": "Please enter old SKU",
    "Please_Enter_New_SKU": "Please enter new SKU",
    "Please_Enter_Total_Replacement_Quantity": "Please enter total replacement quantity",
    "Total_Replacement_Quantity_Cannot_Be_Less_Than_0": "Total replacement quantity cannot be less than 0",
    "The_List_Cannot_Be_Empty": "The list cannot be empty",
    "Please_Enter_Quantity": "Please enter quantity",
    "Quantity_Cannot_Be_Less_Than_0": "Quantity cannot be less than 0",
    "quantity_of_SKU_replacements": "quantity of SKU replacements",
    "Suspend_the_responsible_party_from_the_warehouse": "Suspend the responsible party's access to the warehouse",
    "Delivery_omission": "Missed delivery to warehouse",
    "Cancel_intercept": "Cancel interception",
    "Cancel_delivery_omission": "Cancel missed delivery",
    "client": "Client",
    "staff": "Staff",
    "reason": "Reason",
    "Cancel_intercept_processing": "Cancel interception in process",
    "Cancel_intercept_successfully": "Cancel interception successful",
    "Failed_to_cancel_intercept": "Failed to cancel interception",
    "Delivery_missing_processing": "Missed delivery to warehouse being processed",
    "Delivery_of_missing_processing_completed": "Missed delivery to warehouse processing completed",
    "Failed_to_send_warehouse_missing_processing": "Failed to process missed delivery to warehouse",
    "Cancel_delivery_missing": "Canceling missed delivery to warehouse",
    "Cancel_delivery_missing_complete": "Canceling missed delivery to warehouse completed",
    "Failed_to_cancel_delivery_omission": "Failed to cancel missed delivery",
    "Setting_an_account_failed": "Failed to set up the charge off account",
    "Set_the_account_successfully": "Successfully set up the charge off account",
    "Change_the_shipment_number": "Change the shipment number for re-labeling",
    "Shipment_number_information": "Shipment number information",
    "Charge_Off": "Charge Off",
    "Set_up_an_account": "Set Up a Charge Off Account",
    "Number_of_delivery_pieces": "Number of delivery pieces",
    "Not_Set": "Not Set",
    "Outstanding_account": "Outstanding Account (not yet charged off)",
    "Out_of_account": "Account Closed/Settled (already charged off)",
    "Check_SKU": "Check SKU",
    "Change_mark_or_not": "Replace Label or Not",
    "Total_number_of_label_changes": "Total Number of Label Changes",
    "Actual_number_of_label_changes": "Actual Number of Label Changes",
    "Number_of_repeated_label_changes": "Number of Repeated Label Changes",
    "old_sku": "Old SKU",
    "new_sku": "New SKU",
    "allNum": "Total Quantity",
    "Label_the_outer_box_repeatedly": "Repeatedly Label Outer Box",
    "Cancel_the_repeated_labeling_of_the_outer_box_label": "Cancel Repeated Labeling of Outer Box",
    "Whether_to_set_repeat_replacement": "Whether to Set Repeated Replacement",
    "The_outer_box_label_does_not_actually_change_the_label": "The outer box label does not actually change the product label",
    "Cancel_the_outer_box_label_actually_do_not_change_the_label": "Cancel the setting that the outer box label does not actually change the product label",
    "Set_the_actual_SKU_replacement_information": "Set the actual SKU replacement information",
    "If_the_label_has_been_changed_before,_set_the_actual_number_of_label_changes": "If the label has been changed before, please set the actual number of labels changed.",
    "Label_change_repeatedly": "Repeated label changing",
    "Repeated_switching": "Repeated switching of labels",
    "No_repeated_label_change": "No repeated label changing",
    "Document_source": "Document source",
    "TC_Order_for_goods": "TC Order for goods",
    "Straddle_horse": "Straddle horse",
    "Latin_horse": "Latin horse",
    "Export_the_outbound_order_for_the_secondary_partition": "Export the outbound order for the secondary partition",
    "Export_pdf_test": "Export PDF (Test)",
    "Export_pdf_test2": "Export PDF (Test 2)",
    "Update_remarks": "Update remarks",
    "Export_the_cargo_trajectory_information_of_Mercadolix": "Export the cargo trajectory information of Mercadolix",
    "Create_a_new_extraction_label": "Create a new extraction label",
    "filename": "File name",
    "extract": "Extract",
    "Delivery_date": "Delivery date to warehouse",
    "file_type": "File type",
    "Edit_tag_number": "Edit tag number",
    "Box_label_type": "Box label type",
    "Extraction_in_progress": "Extraction in progress",
    "Extraction_successful": "Extraction successful",
    "Extraction_failure": "Extraction failure",
    "pagination": "Page count",
    "pageNumber": "Page number",
    "picture": "Picture",
    "Tag_number": "Tag number",
    "PDF_link": "PDF link",
    "Please_enter_the_label": "Please enter the label",
    "add_label": "Add label",
    "Merge_and_export_pdf_tags": "Merge and export PDF tags",
    "Add_mode": "Addition mode",
    "Add_source": "Addition source",
    "Export_the_label_of_the_first_level_partition_split_box": "Export the label of the first-level partition split box",
    "Update_title": "Update title",
    "Page_rectangular_box_cropping": "Page rectangular box cropping",
    "clip": "Crop",
    "no_clip": "Do not crop",
    "Batch_download_the_label_of_the_first_level_partition_split_box": "Batch download the label of the first-level partition split box",
    "Label_type": "Label type",
    "Upload_the_segmented_file": "Upload the segmented file",
    "Ordinary_upload": "Ordinary upload",
    "Special_Upload": "Special Upload",
    "Clear_uploaded_files": "Clear uploaded files",
    "Confirm_the_division": "Confirm the division",
    "Label_preview_image": "Label preview image",
    "Draggable_or_clickable": "Draggable or clickable",
    "Segmentation_failed": "Segmentation failed",
    "Segmentation_completed": "Segmentation completed",
    "Unable_to_obtain_the_file_address": "Unable to obtain the file address",
    "Filter_by_page_content": "Filter by page content",
    "filter": "Filter",
    "no_filter": "No filter",
    "Please_delete_the_files_that_failed_to_be_split": "Please delete the files that failed to be split.",
    "Total:": "Total:",
    "zhang": "zhang",
    "A_copy": "A copy",
    "The_number_of_items_rejected_from_the_warehouse": "Number of items rejected upon leaving the warehouse",
    "container_number": "Container number",
    "loading_count": "Loading quantity",
    "scan_detail": "Scan details",
    "Failed_to_get_scan_detail": "Failed to get scan details",
    "Edit_the_cabinet_number_and_remarks": "Edit the container number and remarks",
    "Average_inventory_age": "Average inventory age",
    "Inventory_age_distribution": "Inventory age distribution",
    "Inventory_age_ranking": "Inventory age ranking",
    "Customer_goods_in_warehouse_quantity_ranking": "Customer goods in warehouse quantity ranking",
    "Interval_days": "Interval (days)",
    "quantity_in_stock": "Quantity in stock",
    "Ratio": "Ratio",
    "loading": "Loading",
    "no_more_data": "No more data",
  },
  order: {
    "exchange_number": "exchange number",
    "cargo_departure_time": "cargo departure time",
    "cargo_exit_hold": "cargo exit hold",
    "charge_output_state": "charge output state",
    "type_of_transport": "type of transport",
    "pick_up_order_number/container_number": "pick up order number/container number",
    "shipping_time": "shipping time",
    "status_of_receiving_products": "status of receiving products",
    "cargo_access_code": "cargo access code",
    "load_exit_code": "load exit code",
    "time_to_remove_containers": "time to remove containers",
    "cargo_entry_time": "cargo entry time",
    "warehouse_management": "warehouse management",
    "old_reserve_area": "old reserve area",
    "reserve_area_now": "reserve area now",
    "secondary_shipment_number": "secondary shipment number",
    "new_secondary_shipping_number": "new secondary shipping number",
    "shipping_new/label": "shipping new/label",
    "length": "length",
    "width": "width",
    "height": "height",
    "export_sheet": "export sheet",
    "export_outer_box_label": "export outer box label",
    "export_corresponding_secondary_shipping_sheet": "export corresponding secondary shipping sheet",
    "export_corresponding_secondary_shipment/outer_box_label": "export corresponding secondary shipment/outer box label",
    "delivery_number": "delivery number",
    "shipping/outer_box_label": "shipping/outer box label",
    "export_data": "export data",
    "filter": "filter",
    "reboot": "reboot",
    "total_pieces/piece": "total pieces/piece",
    "total_volume/cubic_meters": "total volume/cubic meters",
    "total_weight/kg": "total weight/kg",
    "state": "state",
    "handling": "handling",
    "Check": "Check",
    "volume/cubic_meters": "volume/cubic meters",
    "weight/kg": "weight/kg",
    "total_pieces": "total pieces",
    "total_weight": "total weight",
    "total_volume": "total volume",
    "piece": "piece",
    "Company_logo": "Company logo",
    "Cargo_status": "Cargo status"
  },
  container: {
    "Print_partition_code": "Print partition code",
    "add_new_container": "add new container",
    "add": "add",
    "delivery_number": "delivery number",
    "container_code": "container code",
    "secondary_shipping/secondary_outer_carton_label": "secondary shipping/secondary outer carton label",
    "volume": "volume",
    "edit": "edit",
    "delete": "delete",
    "close": "close",
    "discharge": "discharge",
    "Cancel": "Cancel",
    "confirm_on_delete_container": "confirm on delete container",
    "edit_container": "edit container",
    "container_name": "container name",
    "save": "save",
    "export_data": "export data",
    "filter": "filter",
    "reboot": "reboot",
    "total_pieces": "total pieces",
    "related_shipping_quantity/pcs": "related shipping quantity/pcs",
    "secondary_shipment_number": "secondary shipment number",
    "cargo_access_code": "cargo access code",
    "piece": "piece",
    "print_container_code": "Print container code",
    "select_all": "select all",
    "Container_log": "container log",
    "batch_delete": "batch delete",
    "Transfer_record": "Transfer record",
    "Large_area_code": "Large area code",
    "pre_transfer": "pre-transfer",
    "post_transfer": "post-transfer",
  },
  abnormalData: {
    "delivery_number": "delivery number",
    "driving_type": "driving type",
    "cargo_entry_time": "cargo entry time",
    "shipping/outer_box_label": "shipping/outer box label",
    "Operating_deadline": "Operating deadline",
    "pieces_uploaded_without_scanning": "pieces uploaded without scanning",
    "paste_label": "paste label",
    "customers": "customers",
    "Salesman": "Salesman",
    "secondary_shipment_number": "secondary shipment number",
    "product_label": "product label",
    "load_output_number": "load output number",
    "cargo_departure_time": "cargo departure time",
    "time_to_remove_containers": "time to remove containers",
    "related_shipping_quantity/pcs": "related shipping quantity/pcs",
    "Warehouse_output_quantity/pieces": "Warehouse output quantity/pieces",
    "amount_of_strange": "amount of strange",
    "successful_scan_parts": "successful scan parts",
    "parts_without_scanning": "parts without scanning",
    "person_responsible_for_shipping": "person responsible for shipping",
    "shipping_car_number": "shipping car number",
    "secondary_shipping/secondary_outer_carton_label": "secondary shipping/secondary outer carton label",
    "quantity_of_products/pieces": "quantity of products/pieces",
    "cargo_entry_number": "cargo entry number",
    "warehouse_receipt_amount/piece": "warehouse receipt amount/piece",
    "pieces_of_strange": "pieces of strange",
    "pieces_without_charge_entry": "pieces without charge entry",
    "type_of_transport": "type of transport",
    "pick_up_order_number/container_number": "pick up order number/container number",
    "Data_export": "Data export",
    "filter": "filter",
    "reset": "reset",
    "piece": "piece",
    "Total_volume": "Total volume",
    "Total_weight": "Total weight",
    "driving": "driving",
    "view": "view",
    "out_warehouse_number": "out warehouse number",
    "title": "title",
    "status": "status",
    "Total": "Total",
    "reject_number": "reject number",
    "intercept_number": "intercept number",
    "creator": "creator",
    "address": "address",
    "create_time": "create time",
    "delivery_time": "delivery time",
    "remark": "remark",
    "delete": "delete",
    "Are_you_sure_to_delete": "Are you sure to delete",
    "cancel": "cancel",
    "waiting_for_out_warehouse": "waiting for out warehouse",
    "warehousing": "warehousing",
    "warehoused": "warehoused",
    "out_warehouse_abnormally": "out warehouse abnormally",
    "deleting": "deleting",
    "Successfully_deleted": "Successfully deleted",
    "Failed_to_get_out_warehouse_list": "Failed to get out warehouse list",
    "Deletion_failure": "Deletion failure",
    "Scan_list": "Scan list",
    "batch_delivery": "batch delivery",
    "out_warehouse_intercept": "out warehouse intercept",
    "Are_you_sure_to_out_warehouse?": "Are you sure to out warehouse?",
    "File_list": "File list",
    "batch_download": "batch download",
    "take_a_photo_and_send_back": "take a photo and send back",
    "download": "download",
    "close": "close",
    "Reject_list": "Reject list",
    "download_attachment": "download attachment",
    "edit": "edit",
    "update_attachment": "update attachment",
    "print_out_warehouse_list": "print out warehouse list",
    "export_out_warehouse_list": "export out warehouse list",
    "Export_the_reject_list": "Export the reject list",
    "all": "all",
    "Scanned": "Scanned",
    "To_be_scanned": "To be scanned",
    "rejection": "rejection",
    "Failed_to_get_out_warehouse_details": "Failed to get out warehouse details",
    "Failed_to_get_scan_list": "Failed to get scan list",
    "Please_check_first": "Please check first",
    "Batch_delivery_successfully": "Batch delivery successfully",
    "Batch_out_warehouse_unsuccessfully": "Batch out warehouse unsuccessfully",
    "Failed_to_get_fileList": "Failed to get fileList",
    "File_is_empty": "File is empty",
    "Download_unsuccessfully": "Download unsuccessfully",
    "Download_successfully": "Download successfully",
    "The_attached_file_is_empty": "The attached file is empty",
    "exporting": "exporting",
    "Export_successfully": "Export successfully",
    "Export_unsuccessfully": "Export unsuccessfully",
    "intercept_reason": "intercept reason",
    "intercepting": "intercepting",
    "Intercept_successfully": "Intercept successfully",
    "Edit_reject_reason": "Edit reject reason",
    "reject_reason": "reject reason",
    "editing": "editing",
    "Edit_successfully": "Edit successfully",
    "Edit_failure": "Edit failure",
    "Update_attachment": "Update attachment",
    "Please_upload_the_attached_file": "Please upload the attached file",
    "Only_xls,_xlsx,_PDF_files_are_supported": "Only xls, xlsx, PDF files are supported",
    "updating": "updating",
    "Update_successfully": "Update successfully",
    "Intercept_unsuccessfully": "Intercept unsuccessfully",
    "Failed_to_get_warehousing_list": "Failed to get warehousing list",
    "warehoused_number": "warehoused number",
    "volume": "volume",
    "weight": "weight",
    "Failed_to_get_warehousing_details": "Failed to get warehousing details",
    "confirm": "confirm",
    "save": "save",
    "Intercepted_number_of_out_warehouse": "Intercepted number of out warehouse",
    "Warehouse_area": "Warehouse area",
    "uploader": "uploader",
    "Upload_time": "Upload time",
    "picture": "picture",
    "TC_sub-order_number": "TC sub-order number",
    "secondary_shipping": "secondary shipping",
    "modifier": "modifier",
    "modifier_time": "modifier time",
    "edit_order_number": "edit order number",
    "please_enter_the_sub-order_number": "please enter the sub-order number",
    "please_enter_the_secondary_shipping": "please enter the secondary shipping",
  },
  baseSetting: {
    "add": "add",
    "brand": "brand",
    "boss/responsible_person": "boss/responsible person",
    "administrator": "administrator",
    "edit": "edit",
    "Delete": "Delete",
    "Sure_to_delete_car_information?": "Sure to delete car information?",
    "Confirm": "Confirm",
    "Cancel": "Cancel",
    "add_car_info": "add car info",
    "car_number": "car number",
    "Car_type": "Car type",
    "Purchased_time": "Purchased time",
    "all_people/everyone": "all people/everyone",
    "regulator/administrator": "regulator/administrator",
    "save": "save",
    "edit_car_info": "edit car info",
    "contact": "contact",
    "phone_contact": "phone contact",
    "detailed_address": "detailed address",
    "add_classification_area": "add classification area",
    "secondary_sorting_quantity/pieces": "secondary sorting quantity/pieces",
    "number_of_pallets/pieces": "number of pallets/pieces",
    "maximum_capacity/cubic_meters": "maximum capacity/cubic meters",
    "sure_to_delete_area_F?": "sure to delete area F?",
    "classification_name": "classification name",
    "maximum_capacity": "maximum capacity",
    "edit_warehouse_information": "edit warehouse information",
    "warehouse_name": "warehouse name",
    "secondary_classification_area": "secondary classification area",
    "add_secondary_sort_area": "add secondary sort area",
    "location_code": "location code",
    "capacity_now": "capacity now",
    "Carboard": "Carboard",
    "Add_carboard": "Add carboard",
    "Carboard_code": "Carboard code",
    "Edit_carboard": "Edit carboard",
    "Carboard_name": "Carboard name",
    "edit_secondary_sort_area": "edit secondary sort area",
    "secondary_sort_area_name": "secondary sort area name",
    "close": "close",
    "download": "download",
    "Total_number_of_pieces": "Total number of pieces",
    "shipping": "shipping",
    "delivery_number": "delivery number",
    "secondary_shipment_number": "secondary shipment number",
    "sure_to_delete": "sure to delete",
    "area": "area",
    "Number_of_subarea": "Number of subarea",
    "Edit_subarea": "Edit subarea",
    "Old_shipment_number": "Old shipment number",
    "scanning_time": "scanning time",
    "shelf": "shelf",
    "Add_shelf": "Add shelf",
    "Export_the_required_location_code_size": "Export the required location code size",
    "Export": "Export",
    "Number_of_layers": "Number of layers",
    "Add_layers": "Add layers",
    "location": "location",
    "Add_location": "Add location",
    "Failed_to_get_the_warehouse_shelf_list": "Failed to get the warehouse shelf list",
    "Failed_to_get_the_layer_number_of_warehouse_list": "Failed to get the layer number of warehouse list",
    "Failed_to_get_the_warehouse_location_list": "Failed to get the warehouse location list",
    "print": "print",
    "Select_All": "Select All",
    "All_complete": "All complete",
    "Please_select_the_print_item_first": "Please select the print item first",
  },
  deliveryReservation: {
    "Daily_Reservation": "Daily Reservation",
    "Last_month": "Last month",
    "today": "today",
    "Next_month": "Next month",
    "Reservation_status": "Reservation status",
    "piece": "piece",
    "Daily_delivery": "Daily delivery",
    "Delivery_instructions": "Delivery instructions",
    "Reservation_time": "Reservation time",
    "Delivery_time": "Delivery time",
    "Shipment_number/shipping_mark": "Shipment number/shipping mark",
    "pieces": "pieces",
    "Cancel_delivery": "Cancel delivery",
    "Confirm_whether_to_cancel_delivery": "Confirm whether to cancel delivery",
    "Successfully_cancel_delivery": "Successfully cancel delivery",
    "Failed_to_cancel_delivery": "Failed to cancel delivery",
    "Failed_to_get_data": "Failed to get data",
    "export": "export",
    "exporting": "exporting",
    "Export_successfully": "Export successfully",
    "Export_unsuccessfully": "Export unsuccessfully",
    "delivery_number": "delivery number",
    "shipping/outer_box_label": "shipping/outer box label",
    "load_output_number": "load output number",
    "filter": "filter",
    "reset": "reset",
    "shipping": "shipping",
    "driving": "driving",
    "confirm": "confirm",
    "cancel": "cancel",
  },
  workorder: {
    "Work_order_number": "Work order number",
    "Associated_order_number": "Associated order number",
    "Operating_state": "Operating state",
    "work_order_node": "work order node",
    "Work_order_type": "Work order type",
    "Problem_type": "Problem type",
    "Creation_time": "Creation time",
    "creator": "creator",
    "Processing_department": "Processing department",
    "filter": "filter",
    "reset": "reset",
    "customer_code": "customer code",
    "Current_processing_department": "Current processing department",
    "Current_processor": "Current processor",
    "Associated_work_order": "Associated work order",
    "Current_node_time": "Current node time",
    "Total_time_spent": "Total time spent",
    "Claim_time": "Claim time",
    "Prescription_of_claim": "Prescription of claim",
    "Operating_time": "Operating time",
    "Description": "Description",
    "remark": "remark",
    "Latest_communication_content": "Latest communication content",
    "view": "view",
    "All": "All",
    "Wait_to_be_done": "Wait to be done",
    "Have_done": "Have done",
    "My_creation": "My creation",
    "Copy_me": "Copy me",
    "Withdrawn": "Withdrawn",
    "rejected": "rejected",
    "submitted": "submitted",
    "finished": "finished",
    "Obsolete": "Obsolete",
    "Have_already_been_created": "Have already been created",
    "In_process": "In process",
    "Failed_to_get_a_CC": "Failed to get a CC",
    "Failed_to_get_the_work_order_type_list": "Failed to get the work order type list",
    "Failed_to_get_the_problem_type_list": "Failed to get the problem type list",
    "Failed_to_get_the_department_list": "Failed to get the department list",
    "Failed_to_get_the_employee_list": "Failed to get the employee list",
    "Failed_to_get_the_work_order_list": "Failed to get the work order list",
    "Failed_to_change_cc_status": "Failed to change  cc status",
    "Basic_information": "Basic information",
    "View_the_change_mark_requirements": "View the change mark requirements",
    "Attached_file": "Attached file",
    "Attached_picture": "Attached picture",
    "Processing_information": "Processing information",
    "Whether_to_view": "Whether to view",
    "Owning_warehouse": "Owning warehouse",
    "Communication_information": "Communication information",
    "Communication_reply": "Communication reply",
    "issuer": "issuer",
    "Carbon_copy_recipient": "Carbon copy recipient",
    "Communication_content": "Communication content",
    "Claim_the_work_order": "Claim the work order",
    "Processing_work_order": "Processing work order",
    "Work_order_processing_log": "Work order processing log",
    "unfold": "unfold",
    "handle": "handle",
    "Pack_up": "Pack up",
    "processor": "processor",
    "Check_the_time": "Check the time",
    "Node_time_consuming": "Node time consuming",
    "Processing_remarks": "Processing remarks",
    "Are_you_sure_you_want_to_claim_a_work_order?": "Are you sure you want to claim a work order?",
    "confirm": "confirm",
    "Cancel": "Cancel",
    "Are_you_sure_you_want_to_complete_a_work_order?": "Are you sure you want to complete a work order?",
    "source": "source",
    "Whether_internal_work_order": "Whether internal work order",
    "initiator": "initiator",
    "Commit_processing": "Commit processing",
    "Finished_work_order": "Finished work order",
    "Withdrawal_processing": "Withdrawal processing",
    "Scrap_ticket": "Scrap ticket",
    "Failed_to_get_domain_name": "Failed to get domain name",
    "Failed_to_get_details": "Failed to get details",
    "Failed_to_get_chat_list": "Failed to get chat list",
    "Failed_to_get_the_log_list": "Failed to get the log list",
    "Reason_for_withdrawal": "Reason for withdrawal",
    "Cause_of_rejection": "Cause of rejection",
    "Reason_for_abandonment": "Reason for abandonment",
    "Claiming": "Claiming",
    "Claim_successfully": "Claim successfully",
    "Failed_to_claim_the_work_order": "Failed to claim the work order",
    "In_completion": "In completion",
    "Complete_success": "Complete success",
    "Failed_to_complete_the_work_order": "Failed to complete the work order",
    "Number_of_packages": "Number of packages",
    "Shipping_slip_number": "Shipping slip number",
    "Old_shipment_number": "Old shipment number",
    "Shipping_mark": "Shipping mark",
    "New_shipment_number": "New shipment number",
    "Old_SKU_logo": "Old SKU logo",
    "New_SKU_logo": "New SKU logo",
    "Please_fill_in": "Please fill in",
    "required": "required",
    "Picture_upload": "Picture upload",
    "Only_support": "Only support",
    "isoformat": "isoformat",
    "Being_submitted": "Being submitted",
    "Submit_successfully": "Submit successfully",
    "Commit_failure": "Commit failure",
    "Processing_result": "Processing result",
    "Failed_to_obtain_the_service_provider_list": "Failed to obtain the service provider list",
    "task_code": "task code",
    "Export_mark_handover": "Export Mark Handover",
    "Batch_assignment_work_order": "Batch Assign Work Order",
    "Added_to_download_list": "Added to Download List",
    "excel_export_failed": "Excel Export Failed",
    "Bind_suborders_in_batches": "Batch Bind Sub-orders",
    "Confirm_binding": "Confirm binding",
    "Processing_priority": "Processing priority",
    "Batch_export_of_goods_details": "Batch export of goods details",
  },
  error: {
    "Sorry_the_page_you_are_looking_for_is_missing": "Sorry, the page you are looking for is missing",
    "To_check_whether_the_URL_you_entered_is_correct_please_click_the_button_below_to_return_to_the_home_page": "To check whether the URL you entered is correct, please click the button below to return to the home page",
    "Back": "Back"
  },
  loadingLot: {
    "delivery_number": "delivery number",
    "shipping": "shipping",
    "creator": "creator",
    "End_time_of_scanning_code": "End time of scanning code",
    "car_number": "car number",
    "filter": "filter",
    "reset": "reset",
    "driving": "driving",
    "view": "view",
    "batch_export": "batch export",
    "lot_number": "lot number",
    "Number_of_packages": "Number of packages",
    "Create_time": "create time",
    "export_data": "export data",
    "lot_information": "lot information",
    "total_pieces": "total pieces",
    "Code_scanner": "Code scanner",
    "Shipment_information": "Shipment information",
    "Code_scanning_information": "Code scanning information",
    "Code_scanning_failure_information": "Code scanning failure information",
    "tc_order_number": "tc order number",
    "Shipment_number": "Shipment number",
    "Number_of_items_to_be_shipped_out": "Number of items to be shipped out",
    "Number_of_scanned_codes": "Number of scanned codes",
    "Missing_pieces": "Missing pieces",
    "Missing_number": "Missing number",
    "TC_sub-order_number": "TC sub-order number",
    "secondary_shipping": "secondary shipping",
    "scanning_time": "scanning time",
    "Cause_of_failure": "Cause of failure",
    "transport_car_no": "license plate number",
    "create_user_realname": "creator",
    "create_time": "creation time",
    "number": "batch number",
    "scan_count": "number of scanned documents"
  },
  returnGoods: {
    "Generate_a_single_barcode": "Generate a single barcode",
    "Batch_barcode_generation": "Batch barcode generation",
    "Shipment_number/shipping_mark": "Shipment number/shipping mark",
    "Input_example": "Input example",
    "Please_enter": "Please enter",
    "Start_number": "Start number",
    "End_number": "End number",
    "Shipping_mark_delimiter": "Shipping mark delimiter",
    "If_the_number_is_set_to_1-10,_it_will_be_generated_in_the_form_of_12345-1_to_12345-10": "If the number is set to 1-10, it will be generated in the form of 12345-1 to 12345-10",
    "Cancel": "Cancel",
    "print": "print",
    "Export": "Export",
    "None": "None",
    "saving": "saving",
    "printing": "printing",
    "Print_successfully": "Print successfully",
    "Failed_to_print": "Failed to print",
    "exporting": "exporting",
    "Export_successfully": "Export successfully",
    "Failed_to_export_the_sheet": "Failed to export the sheet",
    "Platform_type": "Platform type",
    "Return_code": "Return code",
    "Number_of_packages": "Number of packages",
    "Add": "Add",
    "Fill_in_optional": "Fill in optional",
    "Shipment_number": "Shipment number",
    "Delete": "Delete",
    "Return_goods": "Return goods",
    "United_States_and_Mexico": "United States and Mexico",
    "Saving": "Saving",
    "Save_successfully": "Save successfully",
    "Failed_to_save": "Failed to save",
    "Failed_to_obtain_the_platform_type_list": "Failed to obtain the platform type list",
    "Please_select_the_platform_type!": "Please select the platform type!",
    "Failed_to_add_the_shipment_number": "Failed to add the shipment number",
    "The_return_code_can_only_be_added_once": "The return code can only be added once",
    "Please_enter_the_correct_information!": "Please enter the correct information!",
    "adding": "adding",
    "Add_successfully": "Add successfully",
    "Add_failure": "Add failure",
    "Return/US-Mexico_details": "Return/US-Mexico details",
    "TC_order_number": "TC order number",
    "Founder": "Founder",
    "Warehousing_time": "Warehousing time",
    "Total_number_of_packages": "Total number of packages",
    "Order_type": "Order type",
    "Time_of_creation": "Time of creation",
    "Order_information": "Order information",
    "TC_sub-order_number": "TC sub-order number",
    "Sub-shipment_number": "Sub-shipment number",
    "Express_tracking_number": "Express tracking number",
    "Storage_location_information": "Storage location information",
    "The_latest_update_time": "The latest update time",
    "Updater": "Updater",
    "Cargo_picture": "Cargo picture",
    "Print_sheet": "Print sheet",
    "Export_sheet": "Export sheet",
    "Download": "Download",
    "Close": "Close",
    "Failed_to_get_details": "Failed to get details",
    "Failed_to_obtain_form": "Failed to obtain form",
    "generate": "generate",
    "Express_Ticket_number": "Express Ticket number",
    "New_order": "New order",
    "Type_of_order": "Type of order",
    "Type_of_shipment": "Type of shipment",
    "Generate_barcode": "Generate barcode",
    "View_size": "View size",
    "resize": "resize",
    "Private_person": "Private person",
    "Address_template": "Address template",
    "Upload_packing_list": "Upload packing list",
    "Only_files_smaller_than_15_MB_are_supported": "Only files smaller than 15 MB are supported",
    "Modify_size_information_in_batches": "Modify size information in batches",
    "Gross_weight": "Gross weight",
  },
  inventoryCenter: {
    "Edit_operation_time": "Edit operation time",
    "Updated_in_Mexico_local_time": "Updated in Mexico local time",
    "First_shelf_time_(manual)": "First shelf time (manual)",
    "Takedown_time_(manual)": "Takedown time (manual)",
    "Exit_time_(manual)": "Exit time (manual)",
    "Warehousing_time_(manual)": "Warehousing time (manual)",
    "Shelf_time": "Shelf time",
    "Update_the_outbound_time": "Update the outbound time",
    "Outbound_time_(Mexico_time)": "Outbound time (Mexico time)",
  },
  transferWarehouse: {
    "order_number": "order number",
    "shipping_mark": "shipping mark",
    "account_manager": "account manager",
    "reception_time": "reception time",
    "estimated_time_of_delivery": "estimated time of delivery",
    "order_status": "order status",
    "audit_status": "audit status",
    "filter": "filter",
    "reset": "reset",
    "operate": "operate",
    "view": "view",
    "pending": "pending",
    "audited": "audited",
    "failed_to_get": "failed to get",
    "saving": "saving",
    "saved_successfully": "saved successfully",
    "failed_to_save": "failed to save",
    "order_information": "order information",
    "number_of_pieces": "number of pieces",
    "creation_time": "creation time",
    "shelf_start_time": "shelf start time",
    "storage_age": "storage age",
    "finish_shelf_time": "finish shelf time",
    "place_of_dispatch": "place of dispatch",
    "total_weight": "total weight",
    "receiver": "receiver",
    "destination_warehouse": "destination warehouse",
    "total_volume": "total volume",
    "customer_information": "customer information",
    "customer_name": "customer name",
    "contact_person": "contact person",
    "contact_number": "contact number",
    "shipment_information": "shipment information",
    "total_actual_weight": "total actual weight",
    "total_volume(volume_weight)": "total volume(volume weight)",
    "total_square(volume)": "total square (volume)",
    "total_square(actual_weight_divided_by_300)": "total square (actual weight divided by 300)",
    "total_quantity": "total quantity",
    "shipment_status": "shipment status",
    "days_of_storage": "days of storage",
    "hide": "hide",
    "expand": "expand",
    "tc_subtracking_number": "tc subtracking number",
    "sub_shipment_number/shipping_mark": "sub shipment number/shipping mark",
    "length_*_width_*_height_/cm": "length * width * height /cm",
    "gross_weight_/kg": "gross weight /kg",
    "scanned_picture": "scanned picture",
    "scene_picture": "scene picture",
    "sku_name": "sku name",
    "number_of_single_box": "number of single box",
    "view_picture": "view picture",
    "receive_information": "receive information",
    "shipping_contact": "shipping contact",
    "shipping_contact_number": "shipping contact number",
    "receive_signature_picture": "receive signature picture",
    "receive_picture": "receive picture",
    "repudiator": "repudiator",
    "rejection_time": "rejection time",
    "rejection_instructions": "rejection instructions",
    "explanatory_picture": "explanatory picture",
    "remark_information": "remark information",
    "customer_remarks": "customer remarks",
    "internal_remarks": "internal remarks",
    "print_sheet": "print sheet",
    "export_sheet": "export sheet",
    "export_warehouse_list": "export warehouse list",
    "export_customer_box_list": "export customer box list",
    "export_customer_service_box_list": "export customer service box list",
    "export_attachment": "export attachment",
    "off": "off",
    "download": "download",
    "new_sub_shipment_number/shipping_mark": "new sub shipment number/shipping mark",
    "change_type": "change type",
    "old_sub_shipment_number/shipping_mark": "old sub shipment number/shipping mark",
    "original_product_label": "original product label",
    "new_product_label": "new product label",
    "quantity": "quantity",
    "change_area": "change area",
    "uploading": "uploading",
    "upload_successfully": "upload successfully",
    "failed_to_upload": "failed to upload",
    "removing": "removing",
    "removed_successfully": "removed successfully",
    "failed_to_remove": "failed to remove",
    "syncing": "syncing",
    "sync_successfully": "sync successfully",
    "failed_to_sync": "failed to sync",
    "no_data_available": "no data available",
    "exporting": "exporting",
    "warehouse_list": "warehouse list",
    "added_to_the_download_queue": "added to the download queue",
    "failed_to_export": "failed to export",
    "printing": "printing",
    "print_successfully": "print successfully",
    "failed_to_print": "failed to print",
    "piece": "piece",
    "number_of_packages": "number of packages",
    "express_sheet": "express sheet",
    "reject_information": "reject information",
    "delivery_information": "delivery information",
    "operator": "operator",
    "operate_status": "operate status",
    "process_time": "process time",
    "picture": "picture",
    "remark": "remark",
    "accept": "accept",
    "reject": "reject",
    "picture_error,_please_contact_staff!": "Picture error, please contact staff!",
    "New_order": "Create New Order",
    "Order_type": "Order Type",
    "Edit_order_category": "Edit Order Category",
    "Batch_delete": "Batch Delete",
    "Batch_audit": "Batch Approval",
    "Batch_counter_audit": "Batch Reverse Approval",
    "Are_you_sure_you_want_to_do_a_batch_audit": "Are you sure you want to perform a batch approval",
    "Are_you_sure_you_want_to_do_a_batch_counter_audit": "Are you sure you want to perform a batch reverse approval",
    "add": "Add",
    "Delete": "Delete",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "delete_remarks": "Delete Remarks",
    "I_ll_think_about_it_again": "I'll think about it again",
    "Submit_successfully": "Submitted Successfully",
    "Commit_failure": "Submission Failed",
    "Please_check_first": "Please check first",
    "deleting": "Deleting...",
    "Successfully_deleted": "Deleted Successfully",
    "Deletion_failure": "Deletion Failed",
    "In_operation": "In Operation",
    "operation_succeeded": "Operation Succeeded",
    "operation_failure": "Operation Failed",
    "edit": "Edit",
    "status": "Status",
    "Warehousing_time": "Warehousing Time",
    "Subsingle_column_table": "Sub-order List",
    "Number_of_products_tag": "Shipment Number/Shipping Mark",
    "son_order_number": "Sub-order Number",
    "export": "Export",
    "Total_number_of_packages": "Total Number of Packages",
    "Manifest_Agent": "Shipment Information",
    "Add_Manifest_Agent": "Add Shipment Information",
    "edit_size": "Edit Dimensions",
    "Upload_customer_service_box_list": "Upload Customer Service Packing List",
    "Only_files_smaller_than_15_MB_are_supported": "Only files smaller than 15MB are supported",
    "Synchronize_customer_service_box_list": "Synchronize Customer Service Packing List",
    "Are_you_sure_you_want_to_delete": "Are you sure you want to delete",
    "Failed_to_get_order_classification": "Failed to get order classification",
    "Failed_to_get_details": "Failed to get details",
    "Failed_to_obtain_the_goods_information_Procedure": "Failed to obtain the goods information",
    "Data_acquisition_failure": "Data acquisition failure",
    "Failed_to_export_the_sheet": "Failed to export the shipping label",
    "Customer_contact": "Customer Contact",
    "Start_number": "Start Number",
    "End_number": "End Number",
    "serial_number": "Serial Number",
    "length_width_height": "Length * Width * Height",
    "weight": "Weight",
    "add_SKU": "Add SKU",
    "Platform": "Platform",
    "Batch_modify": "Batch Modify Sub-shipment Number Specifications",
    "Length_CM": "Length (CM)",
    "Width_CM": "Width (CM)",
    "Height_CM": "Height (CM)",
    "Weight_KG": "Gross Weight (KG)",
    "Confirm": "Confirm",
    "submit_order": "Submit Order",
    "adding": "Adding",
    "Lieferumfang": "Shipment Number",
    "unfold": "Expand",
    "Pack_up": "Collapse",
    "Being_submitted": "Being Submitted",
    "Failed_to_obtain_the_customer_name_Procedure": "Failed to obtain the customer name",
    "Description_Failed_to_obtain_the_account_manager": "Failed to obtain the account manager",
    "Failed_to_obtain_the_customer_contact_Procedure": "Failed to obtain the customer contact",
    "Failed_to_obtain_contact": "Failed to obtain contact",
    "Platform_acquisition_failure": "Failed to acquire platform",
    "Number_already_exists": "Number already exists",
    "New_failed": "New addition failed",
    "Please_select_the_customer_name_first": "Please select the customer name first",
    "Failed_to_obtain_customer_details": "Failed to obtain customer details",
    "Please_enter_SKU_number_or_name_search": "Please enter SKU number/name for search",
    "sku_code": "SKU Code",
    "selected_sku_count": "Selected SKU Count",
    "Add": "Add",
    "aggregate": "Total",
    "true_weight": "Actual Weight",
    "volumes": "Volumetric Weight",
    "Number_of_squares_300": "Cubic Meters (Actual Weight / 300)",
    "Get_the_results": "Get Calculation Results",
    "save": "Save",
    "Failed_to_obtain_the_calculation_result_Procedure": "Failed to obtain the calculation result",
    "Edit_Customer_information": "Edit Customer Information",
    "contact_person_ensp": "Contact Person",
    "Edit_Sizes": "Edit Dimensions",
    "Sub_shipment_number": "Sub-shipment Number",
    "Failed_to_get_the_SKU_list": "Failed to get the SKU list",
    "upload_attachment": "Upload Attachment",
  },
  other: {
    "batch_intercept": "batch intercept",
    "view_excel_content": "view excel content",
    "tc_order_number": "tc order number",
    "tc_order_id": "tc order id",
    "Shipments_sent_to_Full_or_FBA": "Shipments sent to Full or FBA",
    "change_mark": "change mark",
    "hour": "hour",
    "Export_location_information_(trial)": "Export location information (trial)",
    "have_joined_downlod_queue": "have joined downlod queue",
    "Edit_information": "Edit information",
    "Confirm_the_changes?": "Confirm the changes?",
    "Please_enter_search_criteria": "Please enter search criteria",
    "search": "search",
    "return_claim": "return claim",
    "return_code": "return code",
    "Shipment_number": "Shipment number",
    "export_multi_subarea_outwarehouse_order_list": "export multi subarea outwarehouse order list",
    "secondary_shipment/outer_box_label": "secondary shipment/outer box label",
    "pcs": "pcs",
    "Failed_to_get": "Failed to get",
    "Please_enter_the_license_plate_number": "Please enter the license plate number",
    "Please_select_the_purchase_time": "Please select the purchase time",
    "Are_you_sure_to_add_another_layer_to_this_shelf?": "Are you sure to add another layer to this shelf?",
    "Are_you_sure_to_add_a_storage_location_on_this_shelf?": "Are you sure to add a storage location on this shelf?",
    "Are_you_sure_to_delete_this_shelf?": "Are you sure to delete this shelf?",
    "Are_you_sure_to_delete_the_maximum_number_of_shelves?": "Are you sure to delete the maximum number of shelves?",
    "Are_you_sure_to_delete_this_storage_location?": "Are you sure to delete this storage location?",
    "Shelf_name": "Shelf name",
    "the_number_of_columns_of_location": "the number of columns of location",
    "single": "single",
    "batch": "batch",
    "Add_a_new_container": "Add a new container",
    "Please_enter_the_container_code": "Please enter the container code",
    "The_container_code_is_too_long_Please_re_enter_it": "The container code is too long. Please re-enter it",
    "Add_new_containers_in_batches": "Add new containers in batches",
    "quantity": "quantity",
    "Please_enter_quantity": "Please enter quantity",
    "warehouse": "warehouse",
    "uploading": "uploading",
    "upload_successfully": "upload successfully",
    "failed_to_upload": "failed to upload",
    "out_warehouse": "out warehouse",
    "Sure_out_warehouse?": "Sure out warehouse?",
    "Dispatching": "Dispatching",
    "Successfully_dispatched_from_storage": "Successfully dispatched from storage",
    "Dispatched_from_the_warehouse_unsuccessfully": "Dispatched from the warehouse unsuccessfully",
    "Reject_the_ticket": "Reject the ticket",
    "If_final_processing_is_complete,_select_the_processor_to_make_the_response_(required)": "If final processing is complete, select the processor to make the response (required)",
    "Interior": "Interior",
    "Outside": "Outside",
    "Cargo_information": "Cargo information",
    "Export_Cargo_information": "Export cargo information",
    "inventory_anomaly": "Inventory anomaly",
    "reprint": "reprint",
    "twice": "twice",
    "Batch_update_title": "Batch update title",
    "No_file": "No file yet",
    "batch_delete": "Batch Delete",
    "You_have_selected": "You have selected",
    "pieces_of_document_information_Are_you_sure_you_want_to_delete_them": "pieces of document information. Are you sure you want to delete them",
    "In_operation": "In Operation",
    "Batch_deletion_succeeded": "Batch deletion succeeded",
    "Batch_deletion_failed": "Batch deletion failed",
    "add": "Add",
    "sku_code": "SKU Code",
    "customer_name": "Customer Name",
    "time": "Time",
    "driving": "Action",
    "view": "View",
    "SKU_quantity_*_Unit_price": "SKU Quantity * Unit Price",
    "fail_to_get": "Failed to retrieve",
    "Picking_situation": "Picking Status",
    "date": "Date",
    "abnormal_condition": "Abnormal Condition",
    "total_number_of_packages": "Total Number of Packages",
    "Pick_volume_in_the_last_seven_days": "Picking Volume in the Last Seven Days",
    "line_chart": "Line Chart",
    "histogram": "Histogram",
    "Number_of_pending_orders": "Number of Pending Orders",
    "Order_quantity_in_picking": "Order Quantity in Picking",
    "Quantity_shipped_out_today": "Quantity Shipped Out Today",
    "Refuse_to_return_to_warehouse": "Refuse to Return to Warehouse",
    "Number_of_unpacked_shelves": "Number of Unpacked Shelves",
    "Quantity_of_original_package_transfer": "Quantity of Original Package Transfer",
    "Pick_list_number": "Picking List Number",
    "type": "Type",
    "generated_time": "Generated Time",
    "creation_time": "Creation Time",
    "order_quantity": "Order Quantity",
    "Total_number_of_SKUs": "Total Number of SKUs",
    "filter": "Filter",
    "reset": "Reset",
    "Print_the_pick_list": "Print Picking List",
    "Are_you_sure_you_want_to_generate_a_pick_list": "Are you sure you want to generate a picking list",
    "Select": "Select",
    "print_setup": "Print Settings",
    "Print_without_preview": "Print Without Preview",
    "Printer_name": "Printer Name",
    "Size_input_method": "Size Input Method",
    "Paper_size_W_H_mm": "Paper Size (Width x Height) /mm",
    "Print_test": "Print Test",
    "Open": "Open",
    "Close": "Close",
    "Default": "Default",
    "Custom": "Custom",
    "Connect_to_the_client_first": "Please connect to the client first!",
    "Please_select_a_printer": "Please select a printer",
    "New_cargo_specification": "New Cargo Specification",
    "order_information": "Order Information",
    "batch_number": "Batch Number",
    "state": "Status",
    "number_of_pieces": "Number of Pieces",
    "audit_status": "Audit Status",
    "Outer_box_label_change_status": "Outer Box Label Change Status",
    "Number_of_containers_to_be_replaced": "Number of Containers to be Replaced",
    "The_number_of_changed_packets": "Number of Changed Packets",
    "Number_of_replacement_products": "Number of Replacement Products",
    "Total_number_of_products_that_need_to_be_replaced": "Total Number of Products that Need to be Replaced",
    "Subsingle_column_table": "Suborder List",
    "delivery_number": "Tracking Number",
    "shipping": "Shipping Number",
    "Number_of_products_tag": "Shipping Number/Shipping Mark",
    "son_order_number": "Suborder Number",
    "export": "Export",
    "change_label_status": "Label Change Status",
    "Change_mark_cut_off_state": "Label Change Cut-off State",
    "Set_the_mark_change_cutoff_state": "Set Label Change Cut-off State",
    "goods_info": "Goods Information",
    "Added_the_specification_information_of_cargo_change": "Added Specification Information for Cargo Change",
    "download_attachment": "Download Attachment",
    "edit": "Edit",
    "Check_SKU": "Check SKU",
    "delete": "Delete",
    "export_label_pdf": "Export Label PDF",
    "Are_you_sure_you_want_to_delete": "Are you sure you want to delete",
    "I_ll_think_about_it_again": "I'll think about it again",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "Not_yet_closed": "Not Yet Closed",
    "expired": "Expired",
    "No_change_of_mark": "No Label Change",
    "Changed_mark": "Label Changed",
    "To_be_changed": "To be Changed",
    "changeLabeling": "Changing Label",
    "save": "Save",
    "saving": "Saving",
    "Save_successfully": "Saved Successfully",
    "Save_unsuccessfully": "Save Failed",
    "failed_to_get": "Failed to Get",
    "Please_check_first": "Please check first",
    "exporting": "Exporting",
    "Export_successfully": "Exported Successfully",
    "Export_unsuccessfully": "Export Failed",
    "Failed_to_get_details": "Failed to Get Details",
    "Failed_to_obtain_the_goods_information_Procedure": "Failed to Obtain Goods Information",
    "no_data_available": "No Data Available",
    "Failed_to_export_the_sheet": "Failed to Export Shipping Label",
    "printing": "Printing",
    "Print_successfully": "Printed Successfully",
    "Failed_to_print": "Print Failed",
    "deleting": "Deleting",
    "Successfully_deleted": "Deleted Successfully",
    "Deletion_failure": "Deletion Failed",
    "Download_unsuccessfully": "Download Failed",
    "Number_of_items_that_should_have_outer_box_labels_changed": "Number of Items that Should Have Outer Box Labels Changed",
    "should_sku_num": "Number of SKUs to be Changed",
    "Are_you_sure_you_want_to_delete_it": "Are you sure you want to delete it",
    "New_shipment": "New Shipment",
    "Added_shipment_specification_information": "Added Shipment Specification Information",
    "Mark_change_requirement": "Label Change Requirement",
    "The_outer_box_label_is_replaced_one_by_one": "Outer Box Label Replaced One-by-One",
    "Platform_type": "Platform Type",
    "Change_the_new_shipment_number": "Change New Shipment Number",
    "Change_the_shipment_number": "Change Shipment Number",
    "If_you_only_change_the_product_label_do_not_fill_in": "If only changing the product label, leave this blank",
    "query": "Query",
    "Please_re_check": "Please re-check if you modify 'Label Change Requirement Type' or 'Platform Type'",
    "hide": "Hide",
    "expand": "Expand",
    "original_product_label": "Original Product Label",
    "new_product_label": "New Product Label",
    "number": "Number",
    "add_product": "Add Product Label",
    "remark": "Remark",
    "Label_file_upload": "Upload Label File",
    "Delete_shipment_specifications": "Delete Shipment Specifications",
    "submit": "Submit",
    "Failed_to_obtain_the_platform_type_Procedure": "Failed to Obtain Platform Type",
    "Replace_the_outer_box_label": "Replace Outer Box Label",
    "Change_product_label": "Change Product Label",
    "Replace_the_outer_box_label_and_product_label": "Replace Outer Box Label and Product Label",
    "Query_failure": "Query Failed",
    "Please_select_the_platform_type!": "Please select the platform type!",
    "Please_select_an_address_type": "Please select an address type",
    "Please_add_shipment": "Please add a shipment",
    "Please_fill_in_the_number_of_product_labels_correctly": "Please fill in the number of product labels correctly",
    "Please_fill_in_the_new_product_label": "Please fill in the new product label",
    "Please_fill_in_the_original_product_label": "Please fill in the original product label",
    "The_new_and_old_package_numbers_are_not_equal": "The new and old package numbers are not equal",
    "Please_check_the_new_shipment_number": "Please check the new shipment number",
    "Please_enter_the_new_shipment_number": "Please enter the new shipment number",
    "Quantity_mismatch": "Quantity mismatch",
    "Duplicate_subshipment_numbers_exist_Procedure": "Duplicate subshipment numbers exist",
    "Please_enter_data": "Please enter data",
    "Being_submitted": "Being Submitted",
    "Submit_successfully": "Submitted Successfully",
    "Commit_failure": "Submission Failed",
    "Edit_cargo_information": "Edit Cargo Information",
    "Change_mark_or_not": "Change mark or not",
    "Total_number_of_label_changes": "Total Number of Label Changes",
    "Edit_SKU": "Edit SKU",
    "replace_SKU_or_not": "Replace SKU or not",
    "Change_total_quantity": "Change Total Quantity",
    "Old_SKU": "Old SKU",
    "New_SKU": "New SKU",
    "Update_total_quantity": "Update Total Quantity",
    "allNum": "Total Quantity",
    "Confirm": "Confirm",
    "Add": "Add",
    "Old_SKU_repeat": "Old SKU Repeated",
    "Set_the_storage_start_time": "Set Storage Start Time",
    "Set_storage_end_time": "Set Storage End Time",
    "Failed_to_get_list": "Failed to Retrieve List",
    "outwarehouse_time": "Outbound Time",
    "storage_time": "Storage Duration",
    "number_of_squares": "Square Count",
    "Warehousing_start_time": "Warehousing Start Time",
    "storage_time": "Storage Duration",
    "weight": "Weight",
    "End_of_storage_time": "Warehousing End Time",
    "Billing_phase": "Billing Phase",
    "Restocking_stage": "Restocking Phase",
    "Warehousing_reason": "Warehousing Reason",
    "Calculate_storage_charges": "Calculate Storage Fees",
    "Charging_remarks": "Billing Remarks",
    "Warehouse_remarks": "Warehouse Remarks",
    "charging": "Charging",
    "no_charging": "No Charging",
    "start_time": "Start Time",
    "end_time": "End Time",
    "Updated_in_Mexico_local_time": "Updated according to Mexico's local time",


    "order_number": "Order Number",
    "Picking_condition": "Picking Status",
    "creation_time": "Creation Time",
    "Added_pick_list": "New Pick List",
    "Print_the_express_receipt": "Print Express Label",
    "Add_ing": "Adding...",
    "Add_success": "Add Success",
    "Add_failure": "Add Failure",
    "Please_scan_the_SKU_code": "Please Scan the SKU Code",
    "print": "Print",
    "batch_delivery": "Batch Outbound",
    "outwarehouse": "Outbound",
    "Are_you_sure_to_leave_the_warehouse": "Are you sure to release from warehouse?",
    "operation_succeeded": "Operation Succeeded",
    "operation_failure": "Operation Failure",
    "order_list": "Order List",
    "sku_pick_list": "SKU Pick List",
    "Scan_or_enter_the_container_code": "Please Scan or Enter the Container Code",
    "serial_number": "Serial Number",
    "container_info": "Container Information",
    "scan_out": "Scan for Dispatch",
    "sku_code": "SKU Code",
    "sku_total": "Total SKU Pieces",
    "numeration": "Numbering",
    "sku_total_quantity": "Total SKU Quantity",
    "Unprinted_quantity": "Unprinted Quantity",
    "picking_bill": "Picking Bill",
    "Failed_to_obtain_the_label_library_location_Procedure": "Failed to Obtain Label Location Information",
    "Length": "Length",
    "Width": "Width",
    "Height": "Height",
    "Weight": "Weight",
    "Basic_information": "Basic Information",
    "Pick_list_number": "Pick List Number",
    "Platform_order_number": "Platform Order Number",
    "Express_tracking_number": "Express Tracking Number",
    "Platform": "Platform",
    "tespackaging_informationt": "Packaging Information",
    "Shipping_information": "Shipping Information",
    "contact_person": "Contact Person",
    "phone_contact": "Contact Phone",
    "address": "Address",
    "telephone": "Telephone",
    "city": "City",
    "sku_info": "SKU Information",
    "product_name": "Product Name",
    "Scan_or_enter_the_SKU_code": "Scan or enter the SKU code",
    "Exit_scan": "Exit Scan",
    "Scan_and_print_the_order": "Scan and Print Order",
    "If_the_popup_window_closes_before_the_goods_have_been_scanned_rescan_is_required": "If the popup window closes before scanning is complete, rescanning is required.",
    "quantity_swept": "Quantity Scanned",
    "quantity_unswept": "Quantity Not Scanned",
    "Please_enter_the_SKU_code": "Please Enter the SKU Code",
    "Library_location_number": "Location Number",
    "Shelf_time": "Shelving Time",
    "location": "Location",
    "operator": "Operator",
    "Operating_time": "Operating Time",
    "goods_stock": "Goods Stock",
    "secondary_shipment_number": "Secondary Shipment Number",
    "Sub_shipment_number": "Sub Shipment Number",
    "sku_inventory": "SKU Inventory",
    "quantity_of_goods": "Quantity of Goods",
    "sku_quantity": "SKU Quantity",
    "sku_code_quantity": "SKU Code Quantity",
    "Failed_to_obtain_the_container_list_Procedure": "Failed to Obtain Container List",
    "Failed_to_export_the_container_list_Procedure": "Failed to Export Container List",
    "Warehousing_time": "Warehousing Time",
    "Adjustment_order_number": "Adjustment Order Number",
    "goods_price": "Goods Price",
    "new_construction": "New Construction",
    "Please_enter": "Please Enter",
    "unit_price": "Unit Price",
    "summation": "Total",
    "Order_number_SKU_code": "Order Number/SKU Code",
    "name": "Name",
    "Library_location_log": "Location Log",
    "Failed_to_obtain_log": "Failed to Obtain Log",
    "edit_warehouse_information": "Edit Warehouse Information",
    "warehouse_name": "Warehouse Name",
    "maximum_capacity": "Maximum Capacity",
    "detailed_address": "Detailed Address",
    "editing": "Editing...",
    "Edit_successfully": "Edit Successfully",
    "Edit_failure": "Edit Failure",
    "driving_type": "Operation Type",
    "order_time": "Order Time",
    "price": "Price",
    "shelf_a_product_to_stock": "Shelf Product to Stock",
    "sku_picking_up_goods": "Picking SKU",
    "delivery_record": "Outbound Record",
    "bar_code_printer": "Barcode Printer",
    "Whether_the_goods_have_been_picked": "Whether Goods Have Been Picked",
    "weighting": "Weighting",
    "measure_the_volume": "Measure Volume",
    "odd": "Odd Number",
    "yes": "Yes",
    "no": "No",
    "expense_rule": "Expense Rule",
    "country": "Country",
    "coefficient": "Coefficient",
    "currency": "Currency",
    "Maximum_unilateral_length": "Maximum Unilateral Length",
    "Update": "Update",
    "The_first_weight": "First Weight",
    "minimum_weight": "Minimum Weight",
    "maximum_weight": "Maximum Weight",
    "Stepping": "Stepping",
    "Stepping_price": "Stepping Price",
    "Added_to_download_list": "Added to Download List",
    "Enterprise_management_background": "Enterprise Management Background",
    "log": "Log",
    "Current_storage_location": "Current Storage Location",
    "Old_storage_location": "Old Storage Location",
    "operant_hehavior": "Operational Behavior",
    "Storage_location_status": "Storage Location Status",
    "Operating_remarks": "Operating Remarks",
    "Query_source": "Query Source",
    "Old_inventory": "Old Inventory",
    "New_inventory": "New Inventory",
    "Failed_to_obtain_partition_query_data_Procedure": "Failed to Obtain Partition Query Data",
    "Connect_to_the_client_first_and_then_print": "Please connect to the client first, then print",
    "upload": "Upload",
    "download": "Download",
    "source": "Source",
    "cargo_entry_time": "Cargo Entry Time",
    "Export_the_goods_data_of_the_warehouse_receipt": "Export Goods Data of Warehouse Receipt",
    "Transport_type": "Transport Type",
    "export_list": "Export List",
    "Be_put_in_storage": "Being Put in Storage",
    "All": "All",
    "Confirm_the_modification": "Confirm Modification?",
    "warehousing": "Warehousing",
    "shelving": "Shelving",
    "inventory_checking": "Inventory Checking",
    "current_state": "Current State",
    "Available_today_piece": "Available Today (Pieces)",
    "Todays_inventory_piece": "Today's Inventory (Pieces)",
    "Failed_to_obtain_warehouse_data_time_analysis_data_Procedure": "Failed to Obtain Warehouse Data Time Analysis Data",
    "Failed_to_obtain_warehouse_partition_data": "Failed to Obtain Warehouse Partition Data",
    "Failed_to_obtain_the_card_list_Procedure": "Failed to Obtain Cardboard List",
    "Failed_to_obtain_warehouse_partition_details_Procedure": "Failed to Obtain Warehouse Partition Details",
    "Commercial_Bill_of_Lading": "Commercial Bill of Lading",
    "Waybill_quantity": "Waybill Quantity",
    "cargo_departure_time": "Cargo Departure Time",
    "Outbound_status": "Outbound Status",
    "customer_remarks": "Customer Remarks",
    "Customer_service_remarks": "Customer Service Remarks",
    "Warehouse_Remarks": "Warehouse Remarks",
    "attachment": "Attachment",
    "Batch_confirmation_out_warehouse": "Batch Confirmation of Outbound Warehouse",
    "Batch_cancel_out_warehouse": "Batch Cancellation of Outbound Warehouse",
    "edit_remarks": "Edit Remarks",
    "TC_order_number": "TC Order Number",
    "shipping_mark": "Shipping Mark",
    "sku_name": "SKU Name",
    "waiting_for_out_warehouse": "Waiting for Outbound Warehouse",
    "Out_of_storage": "Out of Storage",
    "Are_you_sure_to_batch_confirm_the_shipment": "Are you sure you want to batch confirm the shipment?",
    "Are_you_sure_you_want_to_cancel_the_shipment_in_bulk": "Are you sure you want to batch cancel the shipment?",
    "Attachment_upload_status": "Attachment Upload Status",
    "Pickup_or_not": "Pickup or Not",
    "The_waybill_has_been_handed_over_to_the_consignee_before_delivery": "Before outbound operation, please confirm that all waybills in the current picking batch have been handed over to the consignee.",
    "Batch_order_number": "Batch Order Number",
    "haven_t_uploaded": "Haven't Uploaded",
    "have_already_uploaded": "Have Already Uploaded",
    "pick_up_in_a_store": "Pick Up in Store",
    "Distribution_collection_point": "Distribution Collection Point",
    "One_out_of_the_warehouse": "One-Piece Fulfillment Outbound",
    "Failed_to_obtain_the_customer_name_list": "Failed to Obtain Customer Name List",
    "Added_to_download_list": "Added to Download List",
    "Please_select_an_address_template": "Please Select an Address Template",
    "export_data": "Data Export",
    "total_pieces_piece": "Total Pieces",
    "total_volume_cubic_meters": "Total Volume (Cubic Meters)",
    "total_weight_kg": "Total Weight (KG)",
    "Update_failure": "Update Failure",
    "Shipment_no_number": "Shipment Number",
    "Failed_to_obtain_the_warehouse_partition_list_Procedure": "Failed to Obtain Warehouse Partition List",
    "Failed_to_obtain_warehouse_details": "Failed to Obtain Warehouse Details",
    "Add_Layer": "Add Layer",
    "Number_of_layers": "Number of Layers",
    "Add_location": "Add Location",
    "location_count": "Location Count",
    "Failed_to_get_the_vehicle_list": "Failed to Get Vehicle List",
    "Add_warehouse_Information": "Add Warehouse Information",
    "Edit_warehouse_Information": "Edit Warehouse Information",
    "pending": "Pending",
    "audited": "Audited",
    "Failed_to_get_the_order_list": "Failed to Get Order List",
    "Failed_to_obtain_shipment_warehouse": "Failed to Obtain Shipment Warehouse",
    "Failed_to_obtain_the_shipping_type_Procedure": "Failed to Obtain Shipping Type",
    "Edit_the_shipment_number": "Edit Shipment Number",
    "Merge_suborder": "Merge Suborder",
    "Please_enter_the_TC_suborder": "Please Enter TC Suborder",
    "detection": "Detection",
    "Subshipment_number_data": "Subshipment Number Data",
    "suborder_data": "Suborder Data",
    "scanning_time": "Scanning Time",
    "Takedown_time": "Takedown Time",
    "Return_time": "Return Time",
    "Data_confirmed_after_merging": "Data Confirmed After Merging",
    "Definite_merge": "Definite Merge",
    "Merger_ing": "Merging",
    "Merger_successful": "Merge Successful",
    "Merge_failure": "Merge Failure",
    "detection_failure": "Detection Failure",
    "The_suborder_determines_the_status": "Suborder Determines Status",
    "uncertain": "Uncertain",
    "confirmed": "Confirmed",
    "storage_age": "Storage Age",
    "Check_the_stream": "Check the Flow",
    "Settlement_of_storage_charges": "Settlement of Storage Charges",
    "Termination_of_charge": "Termination of Charge",
    "tc_subtracking_number": "TC Subtracking Number",
    "Cargo_flow": "Cargo Flow",
    "movement": "Movement",
    "operator2": "Operator",
    "secondary_shipping/secondary_outer_carton_label": "Secondary Shipping/Secondary Outer Carton Label",
    "Warehouse_area": "Warehouse Area",
    "other_description": "Other Description",
    "Whether_to_request_destruction": "Whether to Request Destruction",
    "scan_time": "Scan Time",
    "Are_you_sure_to_destroy_the_goods": "Are you sure you want to destroy the goods?",
    "Failed_to_get_the_inventory_status_list": "Failed to Get Inventory Status List",
    "Failed_to_obtain_the_database_location_list_Procedure": "Failed to Obtain Database Location List",
    "Update_the_outbound_time": "Update Outbound Time",
    "The_number_of_squares_is_zero": "The number of squares is zero",
    "Weight_zero": "Weight is zero",
    "Export_the_customer_box_label": "Export Customer Box Label",
    "Estimated_time_of_arrival": "Estimated Time of Arrival",
    "Failed_to_obtain_the_SKU_list_Procedure": "Failed to Obtain SKU List",
    "Failed_to_obtain_system_details": "Failed to Obtain System Details",
    "Are_they_all_out_of_storage_If_the_product_is_missing_please_enter_the_details_to_specify_the_outlet": "Are they all out of storage? If the product is missing, please enter the details to specify the outlet",
    "All_out": "All items out",
    "Assigns_the_storehouse": "Specifies the outlet for dispatch",
    "Generate_a_pick_list": "Generate a pick list",
    "Allocation_status": "Allocation status",
    "not_generate": "not generate",
    "generated": "generated",
    "Delivery_date": "Warehouse Delivery Date",
    "Number_of_containers_that_have_been_replaced": "Number of Outer Box Labels Already Replaced",
    "Product_label_change_status": "Product Label Replacement Status",
    "Number_of_replaced_product_standards": "Number of Product Labels Already Replaced",
    "Need_to_change_the_outer_box_label": "Outer Box Label Needs Replacement",
    "Need_to_change_the_product_label": "Product Label Needs Replacement",
    "Whether_the_label_has_been_changed": "Label Already Replaced",
    "converted_quantities": "Converted Quantities",
    "Unchanged_quantity": "Unchanged Quantities",
    "Number_of_products_that_need_to_be_replaced": "Number of Products Needing Label Replacement",
    "Change_the_SKU": "SKU Label Change",
    "Old_shipment_number": "Old shipment number",
    "New_shipment_number": "New shipment number",
    "The_shipment_number_has_been_replaced": "Shipment number has been replaced",
    "No_replacement_package_number": "No replacement shipment number provided",
    "The_subshipment_number_should_be_changed": "The sub-shipment number needs to be changed",
    "Label_change_operation_logs": "Label change operation logs",
    "Shipment_number_change": "Change of shipment number label",
    "sku_change": "Change of SKU label",
    "Description_Failed_to_obtain_the_label_change_operation_log": "Failed to obtain the label change operation log",
    "Reload_attachment_information_succeeded_Procedure": "Reload attachment information succeeded",
    "Failed_to_reload_attachment_information_Procedure": "Failed to reload attachment information",
    "Reload_attachment": "Reload attachment",
    "Has_the_outbound_order_been_exported": "Has the outbound order been exported",
    "classify": "Classify",
    "outbound_delivery_order": "Outbound Delivery Order",
    "label": "Label",
    "Batch_download_the_outbound_order_information": "Batch download the outbound order information",
    "Obtain_information": "Obtain information",
    "Achieve_success": "Achieve success",
    "Achieve_failure": "Achieve failure",
    "Obtaining": "Obtaining",
    "Information_has_been_obtained_Please_click_to_export": "Information has been obtained, Please click to export",
    "Whether_to_split": "Whether to Split",
    "Split_files": "Number of Split Items",
    "conditional_split": "Conditional Split",
    "taskname": "Task Name",
    "number_of_packages": "Number of Packages",
    "create_user_realname": "Creator",
    "create_search_goods_task_task": "Create a New Goods Search Task",
    "add_search_goods_task_task": "Add a Goods Search Task",
    "List_of_goods_search_information": "List of Goods Search Information",
    "Batch_input_suborder_numbers": "Batch Input Sub-order Numbers",
    "Export_the_work_order_description": "Export work order description",
    "Delivery_item_number": "Delivery Shipment Number",
    "Container_number": "Container Number",
    "rfid_quantity": "RFID Quantity",
    "Undetected_quantity": "Undetected Quantity",
    "Has_it_been_detected": "Has It Been Detected?",
    "List_of_inbound_inspection_tasks": "List of Inbound Inspection Tasks",
    "The_sublist_was_not_detected": "Undetected Sub-list",
    "The_sublist_has_been_inspected": "Inspected Sub-list",
    "undetected": "Undetected",
    "detected": "Detected",
    "Supplement_the_past_outbound_orders": "Supplement past outbound orders",
    "The_number_of_unchanged_product_labels": "The number of unchanged product labels",
    "Upload_the_manual_label_change_file": "Manual label change file upload",
    "Label_change_type": "Label change type",
    "area": "Area",
    "upload_files": "Upload files",
    "Please_select_the_date_first": "Please select the date first",
    "Failed_to_obtain_the_date": "Failed to obtain the date",
    "Failed_to_obtain_the_repository": "Failed to obtain the repository",
    "store_code": "Warehouse Code",
    "Export_pdf": "Export PDF",
    "box_label": "Box label",
    "Upload_list": "Upload list",
    "old_sku": "original sku",
    "new_sku": "new sku",
    "Inventory_Location_Type": "inventory location type",
    "The_file_name_cannot_contain_special_characters": "The file name cannot contain special characters",
    "Export_the_information_of_goods_leaving_the_warehouse": "Export the information of goods leaving the warehouse",
    "Exit_request_status": "Warehouse exit request status",
    "scan_status": "Scan status",
    "warehouse_loading_status": "Warehouse loading status",
    "Normal_warehouse_exit": "Normal warehouse exit",
    "The_platform_refuses_to_accept": "Platform rejects acceptance",
    "Suspend_position_exit": "Suspend warehouse exit",
    "To_be_scanned": "Pending scanning",
    "Inventory_has_been_scanned_for_release": "Inventory scanned for release",
    "Not_scanned_code": "Unscanned code",
    "Scanned_code": "Scanned code",
    "Has_been_read": "Has Been Read",
    "unread": "Unread",
    "read": "Read",
    "Set_to_read": "Set as Read",
    "Are_you_sure_the_Settings_are_read": "Are you sure to set as read?",
    "occurrence_time": "Occurrence Time",
    "Attention": "Attention",
    "Please_do_not_input_the_file_extension": "Please do not input the file extension",
    "Screenshot_of_the_export_page": "Screenshot of the Export Page",
    "Copy_download_link": "Copy download link",
    "Copy_successfully": "Copy successful",
    "Copy_failed": "Copy failed",
    "Goods_delivered_to_the_warehouse_multiple_times": "Goods delivered to the warehouse multiple times",
    "The_date_cannot_be_empty": "The date cannot be empty",
    "Change_the_number_of_packages": "Modify the number of rebranded items",
    "The_current_number_of_rebranded_items": "Current number of rebranded items",
    "old_warehouse": "old warehouse",
    "current_warehouse": "current warehouse",
    "inbound_date": "Inbound Date",
    "Quantity_in_Stock": "Inbound Quantity",
    "warehouse_selection": "Warehouse Selection",
    "Total_quantity_in_stock": "Total Inbound Quantity",
    "Warehouse_entry_registration": "Warehouse delivery registration",
    "New_Warehouse_entry_registration": "New warehouse delivery registration",
    "reservation_number": "Reservation number",
    "Quantity_of_goods": "Quantity of goods",
    "Please_fill_in_the_information_completely": "Please fill in the information completely",
    "Are_you_sure_you_want_to_cancel_the_reservation_registration": "Are you sure you want to cancel the reservation registration?",
    "Cancel_reservation_registration": "Cancel reservation registration",
    "Update_delivery_time": "Update delivery time",
    "New_import": "New import",
    "update_status": "Update status",
    "Quantity_of_label_changes": "Quantity of label changes",
    "Delivery_method": "Delivery method",
    "Update_the_delivery_method": "Update the delivery method",
    "Failed_to_obtain_the_repository_list": "Failed to obtain the repository list",
    "First_listing_time": "First listing time",
    "Is_the_suborder_empty": "Is the suborder empty",
    "empty": "Empty",
    "non_empty": "Non-empty",
    "In_the_past_month": "Last month",
    "go_back": "Back",
    "dashboard": "Ops quality board",
    "overseas_listing_exception": "Overseas listing exception",
    "total_unlisted_quantity": "Total unlisted",
    "warehousing_date": "Inbound date",
    "container_count": "Containers",
    "quantity_to_be_listed": "To be listed",
    "unlisted_quantity": "Unlisted",
    "overseas_outbound_exception": "Overseas outbound exception",
    "total_rejected_quantity": "Total rejected",
    "total_intercepted_quantity": "Total intercepted",
    "total_unscanned_quantity": "Total unscanned",
    "outbound_date": "Outbound date",
    "rejected_quantity": "Rejected",
    "intercepted_quantity": "Intercepted",
    "unscanned_quantity": "Unscanned",
    "box_damage_summary": "Box damage summary",
    "total_damaged_quantity": "Total damaged",
    "total_repaired_quantity": "Total repaired",
    "damaged_quantity": "Damaged",
    "repaired_quantity": "Repaired",
    "failed_to_get_overseas_listing_exception": "Failed to get overseas listing exception",
    "failed_to_get_overseas_outbound_exception": "Failed to get overseas outbound exception",
    "failed_to_get_box_damage_summary": "Failed to get box damage summary",
    "Change_the_inventory_to_unknown": "Change the inventory to unknown",
    "Are_you_sure_you_want_to_change_the_inventory_to_unknown": "Are you sure you want to change the inventory to unknown",
    "Is_there_any_rejection": "Is there any rejection",
  },
}